/* eslint-disable react/prop-types */
import React from "react";
import "../App.css";
const Radiobtn = ({ labelName, options, value, onChange, extraClass }) => {
  return (
    <div className="d-flex mb-2 align-items-center label-wrap">
      <label className="label">{labelName}</label>
      {options?.map((item, index) => {
        return (
          <span key={index} className={`radiobtnspan mx-2 ${extraClass}`}>
            <input
              key={item._id}
              type="radio"
              name="level"
              className="mx-2"
              checked={item._id === value}
              onChange={() => onChange(item._id)}
            />
            {item.name}
          </span>
        );
      })}
    </div>
  );
};
export default Radiobtn;
